// Cuanto se le descuenta a un jugador en una parcialidad, y por cual promocion.
//
// Antes vivia dentro de reasignarPlanJugador y decidia con
// pagos_promociones.scope, que tenia tres ramas implementadas (todos / jugador /
// familia) y una CUARTA que la UI ofrecia y el codigo nunca implemento: 'grupo'.
// Una promocion de grupo quedaba guardada, activa y visible, y no le aplicaba a
// nadie -- sin error y sin aviso. El club prometia un descuento y cobraba
// completo.
//
// Ahora hay una sola regla: aplica a quien este asignado. Grupo y familia pasan
// a ser formas de SELECCIONAR en la pantalla, que se expanden a jugadores al
// asignar. Con eso la rama que faltaba deja de importar: se borro el concepto en
// vez de parchar el hueco.
//
// Que porcentaje le toca al hijo numero N de una escalera de hermanos.
//
// UNA promocion cubre a TODAS las familias: no es "el descuento para familias de
// tres", es la escalera completa. El primer hijo nunca lleva descuento -- el
// beneficio empieza en el segundo.
//
// Un escalon vacio HEREDA el de arriba: configurar solo "2do: 10%" significa "del
// segundo en adelante, 10%". Por eso una promocion que solo llena el escalon del
// tercero le da CERO al segundo, que es justo la confusion que hay que evitar en
// la pantalla.
//
// La comparte el formulario de Promociones para enseñar la escalera resultante:
// asi lo que se ve al configurar es literalmente lo que va a cobrar.
export const porcentajeHermano = (config = {}, posicion = 1) => {
  if (!(posicion >= 2)) return 0
  for (let n = posicion; n >= 2; n--) {
    const valor = Number((config || {})[`hijo_${n}`] || 0)
    if (valor) return valor
  }
  return 0
}

// Puro: recibe lo ya consultado. `_jugadorIds` lo arma el llamador desde
// pagos_promociones_jugadores.
export const calcularDescuento = ({
  promociones = [], jugadorId, jugadorFamilia = {}, jugadorPosicion = {}, parc, planId,
} = {}) => {
  let mejorDescuento = 0
  let mejorPromocionId = null

  for (const promo of (promociones || [])) {
    if (!(promo._jugadorIds || []).includes(jugadorId)) continue

    if (promo.plan_id && promo.plan_id !== planId) continue
    if (promo.concepto_id && promo.concepto_id !== parc?.concepto_id) continue

    let descuento = promo.porcentaje || 0

    if (promo.tipo === 'hermano' && jugadorFamilia[jugadorId]) {
      // El monto NO sale de la promocion sino de que hijo es: la asignacion dice
      // quien tiene el beneficio, la config dice cuanto le toca.
      descuento = porcentajeHermano(promo.config, jugadorPosicion[jugadorId] || 1)
    }

    if (descuento > mejorDescuento) {
      mejorDescuento = descuento
      mejorPromocionId = promo.id
    }
  }

  return { descuento: mejorDescuento, promocionId: mejorPromocionId }
}
